import React from 'react'
import {CheckCircle, XCircle} from 'lucide-react'

interface ProsConsBoxProps {
  pros: string[]
  cons: string[]
}

const ProsConsBox: React.FC<ProsConsBoxProps> = ({ pros, cons }) => {
  return (
    <div className="grid md:grid-cols-2 gap-6 my-8">
      {/* Pros */}
      <div className="bg-green-50 border-2 border-green-200 rounded-lg p-6">
        <div className="flex items-center mb-4">
          <CheckCircle className="text-green-600 mr-2" size={24} />
          <h4 className="text-lg font-bold text-gray-900">Pros</h4>
        </div>
        <ul className="space-y-2">
          {pros.map((pro, index) => (
            <li key={index} className="flex items-start text-gray-700">
              <span className="text-green-600 mr-2 mt-1">✓</span>
              <span>{pro}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Cons */}
      <div className="bg-red-50 border-2 border-red-200 rounded-lg p-6">
        <div className="flex items-center mb-4">
          <XCircle className="text-red-600 mr-2" size={24} />
          <h4 className="text-lg font-bold text-gray-900">Cons</h4>
        </div>
        <ul className="space-y-2">
          {cons.map((con, index) => (
            <li key={index} className="flex items-start text-gray-700">
              <span className="text-red-600 mr-2 mt-1">✗</span>
              <span>{con}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default ProsConsBox
